export const convertEmptyArrayToNull = (arr, isSingle) => {
  if (arr === undefined || arr === null) {
    return null;
  }

  if (typeof arr === 'string') {
    return arr;
  }

  if (typeof arr === 'object' && typeof arr.length === 'number' && arr?.length !== 0) {
    if (isSingle) {
      return arr[0];
    }
    return arr;
  }
  return null;
};
